var App = function () {
  window.addEventListener('DOMContentLoaded', function () {
    init()
  })

  ///////////////////////////////////////////////////////////////////////////////////
  // Carousel Function
  let carousel = (carouselIdArray) => {
    carouselIdArray.forEach(carouselId => {
      if (document.getElementById(carouselId) == null) {return}
      const slides = document.getElementById(carouselId).querySelectorAll(".slide");
      const next = document.getElementById(carouselId).querySelector(".arrows .right");
      const prev = document.getElementById(carouselId).querySelector(".arrows .left");
      const crumbs = document.getElementById(carouselId).querySelectorAll(".carousel .crumbs li button");
      let counter = 0 ;
      let slidNum = slides.length

      let changeCrumbActive = (activeNum) => {
        crumbs.forEach(crumb => {
          crumb.classList.remove("active")
        })
        crumbs[activeNum].classList.add("active")
      }

      let slideEffect = (newNum) => {
        // Prev
        if (counter < newNum && newNum != -1 && newNum != slidNum) {
          slides[newNum].classList.add("slide-next")
          setTimeout(() => {
            slides[counter].classList.add("slide-left")
            slides[newNum].classList.add("slide-left")
          }, 1);
          setTimeout(() => {
            slides[counter].classList.remove("slide-left", "active")
            slides[newNum].classList.remove("slide-next", "slide-left")
            slides[newNum].classList.add("active")
            changeCrumbActive(newNum)
            counter = newNum;
          }, 400);
        }

        // Next
        if (counter > newNum && newNum != -1 && newNum != slidNum) {
          slides[newNum].classList.add("slide-prev")
          setTimeout(() => {
            slides[counter].classList.add("slide-right")
            slides[newNum].classList.add("slide-right")
          }, 1);
          setTimeout(() => {
            slides[counter].classList.remove("slide-right", "active")
            slides[newNum].classList.remove("slide-prev", "slide-right")
            slides[newNum].classList.add("active")
            changeCrumbActive(newNum)
            counter = newNum;
          }, 400);
        }

        // Prev - from slide 1 to last slide
        if (counter === 0 && newNum === -1) {
          slides[slidNum - 1].classList.add("slide-prev")
          setTimeout(() => {
            slides[counter].classList.add("slide-right")
            slides[slidNum - 1].classList.add("slide-right")
          }, 1);
          setTimeout(() => {
            slides[counter].classList.remove("slide-right", "active")
            slides[slidNum - 1].classList.remove("slide-prev", "slide-right")
            slides[slidNum - 1].classList.add("active")
            changeCrumbActive(slidNum - 1)
            counter = slidNum - 1;
          }, 400);
        }

        // NEXT - from last slide to first slide
        if (counter === crumbs.length -1 && newNum === crumbs.length) {
          slides[0].classList.add("slide-next")
          setTimeout(() => {
            slides[counter].classList.add("slide-left")
            slides[0].classList.add("slide-left")
          }, 1);
          setTimeout(() => {
            slides[counter].classList.remove("slide-left", "active")
            slides[0].classList.remove("slide-next", "slide-left")
            slides[0].classList.add("active")
            changeCrumbActive(0)
            counter = 0;
          }, 400);
        }
      }

      // Next button function
      next.addEventListener("click",()=>{
        slideEffect(counter + 1);
      });

      // Prev button function
      prev.addEventListener("click",()=>{
        slideEffect(counter - 1);
      });

      // Crumb button function
      for (let i = 0; i < crumbs.length; i++) {
        crumbs[i].addEventListener("click", () => {
          if (i>=slides.length || i<0)return;
          slideEffect(i);
        })
      }

      // swipe
      let touchStartPosition
      let touchchange
      let changePercentage
      let lock = false

      for (let i = 0; i < slides.length; i++) {
        slides[i].addEventListener("touchstart", e => {
          if (!lock) {
            touchStartPosition = e.touches[0].clientX;
            lock = true
          }
        });

        document.addEventListener("touchmove", e => {
          if (lock) {
             touchchange = e.changedTouches[0].clientX;

              // prev
              if (touchchange > touchStartPosition) {
                changePercentage = Math.round(((touchStartPosition - touchchange)/slides[i].clientWidth)*-100)

                if (changePercentage > 20 && changePercentage < 100 && Number.isInteger(changePercentage)) {
                  slideEffect(counter - 1);
                  lock = false
                }
              }

              // next
              if (touchchange < touchStartPosition) {
                changePercentage = Math.round(((touchStartPosition - touchchange)/slides[i].clientWidth)*100)

                if (changePercentage > 20 && changePercentage < 100 && Number.isInteger(changePercentage)) {
                  slideEffect(counter + 1);
                  lock = false
                }
              }
          }
        });

        document.addEventListener("touchend", e => {
          lock = false
        });
      }
      
    })
  }
  // END Carousel Function
  ///////////////////////////////////////////////////////////////////////////////////


  let checkScrolling = () => {
    let mainlogoheight = document.querySelector("#main-logo").offsetHeight
    document.addEventListener("scroll", () => {
    if(window.pageYOffset <= 20) {
        document.body.classList.remove("scrolled");
        document.getElementById("main-logo").setAttribute("aria-hidden","false");
        document.getElementById("nav-logo").setAttribute("aria-hidden","true");
      } else {
        document.body.classList.add("scrolled");
        document.getElementById("main-logo").setAttribute("aria-hidden","true");
        document.getElementById("nav-logo").setAttribute("aria-hidden","false");
      }
    });
  }


  // let moveToTop = () => {
  //   const toTopBtns = document.querySelectorAll(".to-top");
  //   toTopBtns.forEach(btn => {
  //     btn.addEventListener("click",()=>{
  //       // window.scrollTo(0, 0);
  //       window.scrollTo({top: 0, behavior: 'smooth'});
  //     });
  //   })
  // }



  // Transcript open close functionality
  let runTranscript = () => {
    let transcriptTogglebtn = document.querySelector(".toggle-transcript-btn")
    let transscriptTextHeight =  document.querySelector("#transcript-text").offsetHeight
    let transscriptText = document.getElementById("transcript-container")


    let transcriptToggle = () => {
      if (transcriptTogglebtn.classList.contains("active")) {
        transcriptTogglebtn.classList.remove("active")
        transscriptText.classList.remove("active")
      } else {
        transcriptTogglebtn.classList.add("active")
        transscriptText.style.height = `${transscriptTextHeight}px`
        setTimeout(() => {
          transscriptText.classList.add("active")
          transscriptText.removeAttribute("style")
        }, 400);
      }
    }

    transcriptTogglebtn.addEventListener("click",()=>{
      transcriptToggle()
    });
  }
  





  const init = () => {
    //let scrollManager = new ScrollManager()

    checkScrolling()
    runTranscript()

    // Run array of Carousels by carousel id
    carousel(["phone-img-carousel"])
    
  }
}

var _app = new App()